import {Button, Flex, Typography, theme} from 'antd';
import React from 'react';
import PropTypes from 'prop-types';
import {useCSContext} from 'Context/ContentStackContext';
import DialogWrapper from './DialogWrapper';
import styles from './styles';
import {GIFTING} from '../../giftingConstants';

const GiftDialogError = ({openErrorDialog, setOpenErrorDialog, errorMessage}) => {
  const {artifacts} = useCSContext();
  const {token}: any = theme.useToken();

  return (
    <DialogWrapper closeDialogMethod={setOpenErrorDialog} open={openErrorDialog}>
      <Flex
        vertical
        gap={12}
        style={{
          ...styles.container,
          background: token.colorErrorBg,
          borderRadius: token.borderRadiusLG,
          padding: 24,
        }}>
        <img src={artifacts.gift_icon} alt="" style={{fontSize: 70, alignSelf: 'center'}} />
        <Typography.Title level={4} style={{margin: 0, color: token.colorError}}>
          {GIFTING.gifting_dialog_error.heading}
        </Typography.Title>
        <Typography.Text style={{textAlign: 'center', color: token.colorError}}>
          {GIFTING.gifting_dialog_error.error_map[errorMessage]}
        </Typography.Text>
      </Flex>
      <div style={styles.buttonBox}>
        <Button onClick={() => setOpenErrorDialog(false)} style={styles.button}>
          {GIFTING.gifting_dialog_error.button_text}
        </Button>
      </div>
    </DialogWrapper>
  );
};

GiftDialogError.propTypes = {
  openErrorDialog: PropTypes.bool,
  setOpenErrorDialog: PropTypes.func,
  errorMessage: PropTypes.string,
};

export default GiftDialogError;
